<template lang="pug">
  include /mixins
  div(v-if='!authUser')
    +b.tt-checkout-user-type-trigger
      +e.variant(
        @click.prevent='change(false)'
        :class='isOldUser ? "is-passive": "is-selected"'
      )
        +e.title.P {{ _('Я новый покупатель') }}
      +e.variant(
        @click.prevent='change(true)'
        :class='isOldUser ? "is-selected": "is-passive"'
      )
        +e.title.P {{ _('Я постоянный клиент') }}

</template>

<script>
export default {
  name: 'UserTypeTrigger',
  data() {
    return {
      authUser: window.authent,
      isOldUser: false,
    }
  },
  methods: {
    change(value) {
      this.isOldUser = value
      this.$emit('user:type:update', this.isOldUser)
    },
  },
}
</script>
